// Datos mock listos para reemplazar por Firebase mas adelante.
export const productosMock = [
  {
    id: "pizza-mediterranea",
    nombre: "Gran Mediterranea",
    descripcion: "Tomate, mozzarella, aceitunas negras, rucula y feta.",
    categoria: "Pizzas",
    disponible: true,
    presentacionesPermitidas: ["PORCIONES_4", "PORCIONES_8"],
    precios: { PORCIONES_4: 5200, PORCIONES_8: 9800 },
  },
  {
    id: "pizza-pepperoni",
    nombre: "Pepperoni XXL",
    descripcion: "Salsa casera, doble pepperoni y mix de quesos.",
    categoria: "Pizzas",
    disponible: true,
    presentacionesPermitidas: ["PORCIONES_4", "PORCIONES_8"],
    precios: { PORCIONES_4: 5600, PORCIONES_8: 10400 },
  },
  {
    id: "pizza-cuatro-quesos",
    nombre: "Cuatro Quesos",
    descripcion: "Mozzarella, provolone, azul y sardo.",
    categoria: "Pizzas",
    disponible: true,
    presentacionesPermitidas: ["PORCIONES_4", "PORCIONES_8"],
    precios: { PORCIONES_4: 5400, PORCIONES_8: 10100 },
  },
  {
    id: "pizza-barbacoa",
    nombre: "Barbacoa Ahumada",
    descripcion: "Pollo braseado, cebolla morada y salsa BBQ.",
    categoria: "Pizzas",
    disponible: true,
    presentacionesPermitidas: ["PORCIONES_4", "PORCIONES_8"],
    precios: { PORCIONES_4: 5700, PORCIONES_8: 10800 },
  },
  {
    id: "pizza-trufa",
    nombre: "Trufa y Hongos",
    descripcion: "Crema de ajo, portobellos y aceite de trufa.",
    categoria: "Pizzas",
    disponible: false,
    presentacionesPermitidas: ["PORCIONES_4", "PORCIONES_8"],
    precios: { PORCIONES_4: 5900, PORCIONES_8: 11200 },
  },
  {
    id: "pizza-vegana",
    nombre: "Veggie Power",
    descripcion: "Vegetales grillados, pesto y mozzarella vegana.",
    categoria: "Pizzas",
    disponible: true,
    presentacionesPermitidas: ["PORCIONES_4", "PORCIONES_8"],
    precios: { PORCIONES_4: 5200, PORCIONES_8: 9900 },
  },
  {
    id: "pizza-napolitana",
    nombre: "Napolitana Clasica",
    descripcion: "Tomate, mozzarella, ajo y oregano.",
    categoria: "Pizzas",
    disponible: true,
    presentacionesPermitidas: ["PORCIONES_4", "PORCIONES_8"],
    precios: { PORCIONES_4: 4800, PORCIONES_8: 9100 },
  },
  {
    id: "pizza-provoleta",
    nombre: "Provoleta Picante",
    descripcion: "Provoleta fundida, ajies y perejil.",
    categoria: "Pizzas",
    disponible: true,
    presentacionesPermitidas: ["PORCIONES_4", "PORCIONES_8"],
    precios: { PORCIONES_4: 5500, PORCIONES_8: 10300 },
  },
  {
    id: "pizza-jamon-rucula",
    nombre: "Jamon Crudo y Rucula",
    descripcion: "Jamon crudo, rucula fresca y parmesano.",
    categoria: "Pizzas",
    disponible: true,
    presentacionesPermitidas: ["PORCIONES_4", "PORCIONES_8"],
    precios: { PORCIONES_4: 5900, PORCIONES_8: 11000 },
  },
  {
    id: "pizza-fugazzeta",
    nombre: "Fugazzeta Rellena",
    descripcion: "Cebolla caramelizada y queso en el centro.",
    categoria: "Pizzas",
    disponible: true,
    presentacionesPermitidas: ["PORCIONES_4", "PORCIONES_8"],
    precios: { PORCIONES_4: 5600, PORCIONES_8: 10500 },
  },
  {
    id: "pizza-margherita",
    nombre: "Margherita",
    descripcion: "Salsa italiana, mozzarella y albahaca.",
    categoria: "Pizzas",
    disponible: true,
    presentacionesPermitidas: ["PORCIONES_4", "PORCIONES_8"],
    precios: { PORCIONES_4: 5000, PORCIONES_8: 9500 },
  },
  {
    id: "prepizza-tradicional",
    nombre: "Prepizza Tradicional",
    descripcion: "Masa lista para hornear, estilo clasico.",
    categoria: "Prepizzas",
    disponible: true,
    presentacionesPermitidas: ["PORCIONES_8", "PIZZERIA_6PACK"],
    precios: { PORCIONES_8: 3600, PIZZERIA_6PACK: 18500 },
  },
  {
    id: "prepizza-integral",
    nombre: "Prepizza Integral",
    descripcion: "Masa integral con semillas, lista para horno.",
    categoria: "Prepizzas",
    disponible: true,
    presentacionesPermitidas: ["PORCIONES_8", "PIZZERIA_6PACK"],
    precios: { PORCIONES_8: 3900, PIZZERIA_6PACK: 19800 },
  },
  {
    id: "prepizza-sin-gluten",
    nombre: "Prepizza Sin Gluten",
    descripcion: "Masa de arroz y mandioca, sin TACC.",
    categoria: "Prepizzas",
    disponible: false,
    presentacionesPermitidas: ["PORCIONES_8"],
    precios: { PORCIONES_8: 4200 },
  },
  {
    id: "prepizza-focaccia",
    nombre: "Focaccia para Pizza",
    descripcion: "Base esponjosa con aceite de oliva.",
    categoria: "Prepizzas",
    disponible: true,
    presentacionesPermitidas: ["PORCIONES_8", "PIZZERIA_6PACK"],
    precios: { PORCIONES_8: 4100, PIZZERIA_6PACK: 21000 },
  },
  {
    id: "derivado-faina",
    nombre: "Faina Clasica",
    descripcion: "Faina suave con aceite de oliva.",
    categoria: "Derivados",
    disponible: true,
    presentacionesPermitidas: ["PORCIONES_4", "PORCIONES_8"],
    precios: { PORCIONES_4: 2100, PORCIONES_8: 3800 },
  },
  {
    id: "derivado-faina-romero",
    nombre: "Faina con Romero",
    descripcion: "Faina aromatizada con romero fresco.",
    categoria: "Derivados",
    disponible: true,
    presentacionesPermitidas: ["PORCIONES_4", "PORCIONES_8"],
    precios: { PORCIONES_4: 2300, PORCIONES_8: 4200 },
  },
  {
    id: "derivado-pan-ajo",
    nombre: "Pan de Ajo",
    descripcion: "Bastones de pan con ajo y manteca.",
    categoria: "Derivados",
    disponible: true,
    presentacionesPermitidas: ["PORCIONES_4"],
    precios: { PORCIONES_4: 2600 },
  },
  {
    id: "derivado-empanadas",
    nombre: "Empanadas de Pizza",
    descripcion: "Docena mixta de sabores clasicos.",
    categoria: "Derivados",
    disponible: true,
    presentacionesPermitidas: ["PIZZERIA_6PACK"],
    precios: { PIZZERIA_6PACK: 9000 },
  },
  {
    id: "derivado-caldo",
    nombre: "Calzone de Jamon y Queso",
    descripcion: "Calzone con jamon cocido y mozzarella.",
    categoria: "Derivados",
    disponible: true,
    presentacionesPermitidas: ["PORCIONES_4"],
    precios: { PORCIONES_4: 5200 },
  },
  {
    id: "combo-duo",
    nombre: "Combo Duo",
    descripcion: "2 pizzas medianas + 1 gaseosa 1.5L.",
    categoria: "Combos",
    disponible: true,
    presentacionesPermitidas: ["PIZZERIA_6PACK"],
    precios: { PIZZERIA_6PACK: 17500 },
  },
  {
    id: "combo-familiar",
    nombre: "Combo Familiar",
    descripcion: "2 pizzas grandes + faina + bebida.",
    categoria: "Combos",
    disponible: true,
    presentacionesPermitidas: ["PIZZERIA_6PACK"],
    precios: { PIZZERIA_6PACK: 22800 },
  },
  {
    id: "combo-amigos",
    nombre: "Combo Amigos",
    descripcion: "3 pizzas grandes y papas rusticas.",
    categoria: "Combos",
    disponible: true,
    presentacionesPermitidas: ["PIZZERIA_6PACK"],
    precios: { PIZZERIA_6PACK: 29800 },
  },
  {
    id: "combo-oficina",
    nombre: "Combo Oficina",
    descripcion: "6 prepizzas + 2 salsas listas.",
    categoria: "Combos",
    disponible: false,
    presentacionesPermitidas: ["PIZZERIA_6PACK"],
    precios: { PIZZERIA_6PACK: 24000 },
  },
  {
    id: "pizza-primavera",
    nombre: "Primavera",
    descripcion: "Tomate, mozzarella, cherry y albahaca.",
    categoria: "Pizzas",
    disponible: true,
    presentacionesPermitidas: ["PORCIONES_4", "PORCIONES_8"],
    precios: { PORCIONES_4: 5200, PORCIONES_8: 9700 },
  },
  {
    id: "pizza-picante",
    nombre: "Diavola",
    descripcion: "Salame picante, morron asado y cebolla.",
    categoria: "Pizzas",
    disponible: true,
    presentacionesPermitidas: ["PORCIONES_4", "PORCIONES_8"],
    precios: { PORCIONES_4: 5700, PORCIONES_8: 10700 },
  },
  {
    id: "pizza-pollo",
    nombre: "Pollo al Verdeo",
    descripcion: "Pollo grillado, verdeo y crema suave.",
    categoria: "Pizzas",
    disponible: true,
    presentacionesPermitidas: ["PORCIONES_4", "PORCIONES_8"],
    precios: { PORCIONES_4: 5600, PORCIONES_8: 10600 },
  },
  {
    id: "pizza-patagonica",
    nombre: "Patagonica",
    descripcion: "Cordero braseado, cebolla y provolone.",
    categoria: "Pizzas",
    disponible: false,
    presentacionesPermitidas: ["PORCIONES_4", "PORCIONES_8"],
    precios: { PORCIONES_4: 6400, PORCIONES_8: 12200 },
  },
  {
    id: "derivado-salsa",
    nombre: "Salsa Pomodoro",
    descripcion: "Salsa casera para prepizzas.",
    categoria: "Derivados",
    disponible: true,
    presentacionesPermitidas: ["PORCIONES_4"],
    precios: { PORCIONES_4: 1800 },
  },
  {
    id: "derivado-papas",
    nombre: "Papas Rusticas",
    descripcion: "Papas horneadas con especias.",
    categoria: "Derivados",
    disponible: true,
    presentacionesPermitidas: ["PORCIONES_4"],
    precios: { PORCIONES_4: 3500 },
  },
  {
    id: "combo-martes",
    nombre: "Promo Martes",
    descripcion: "2 pizzas muzza por precio especial.",
    categoria: "Combos",
    disponible: true,
    presentacionesPermitidas: ["PIZZERIA_6PACK"],
    precios: { PIZZERIA_6PACK: 15800 },
  },
  {
    id: "prepizza-muzzarella",
    nombre: "Prepizza con Muzzarella",
    descripcion: "Base con salsa y muzzarella lista para horno.",
    categoria: "Prepizzas",
    disponible: true,
    presentacionesPermitidas: ["PORCIONES_8", "PIZZERIA_6PACK"],
    precios: { PORCIONES_8: 4400, PIZZERIA_6PACK: 21400 },
  },
];
